import styles from './FadedCard.module.scss';

export const FadedCard = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.fadedCard}>{children}</div>;
};
